module.exports = __webpack_public_path__ + "static/img/recruitThree.3a39d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageFour/recruitThree.png
// module id = a2hN
// module chunks = 0